import { useState, useEffect, useRef } from 'react';
import { Play, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const LandingTutorialPopup = () => {
  const [video, setVideo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/tutorial-video`)
      .then(res => { if (res.data) setVideo(res.data); })
      .catch(() => {});
  }, []);

  if (!video || dismissed) return null;

  const handleOpen = () => setModalOpen(true);

  const handleClose = () => {
    setModalOpen(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setDismissed(true);
  };

  return (
    <>
      {/* Floating Button */}
      {!modalOpen && (
        <div className="fixed bottom-6 right-6 z-50 flex items-center gap-2" data-testid="tutorial-fab">
          <button
            onClick={handleDismiss}
            className="bg-slate-800/80 hover:bg-slate-700 text-white/70 hover:text-white rounded-full w-6 h-6 flex items-center justify-center transition-all shadow-md"
            data-testid="tutorial-fab-dismiss"
            aria-label="Fechar"
          >
            <X className="h-3.5 w-3.5" />
          </button>
          <button
            onClick={handleOpen}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold px-5 py-3 rounded-full shadow-xl flex items-center gap-2.5 transition-all transform hover:-translate-y-0.5 hover:shadow-2xl"
            data-testid="tutorial-fab-open"
          >
            <Play className="h-5 w-5 fill-current" />
            <span className="text-sm">Como Usar</span>
          </button>
        </div>
      )}

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="tutorial-modal">
          <div className="relative w-full max-w-4xl mx-4">
            <div className="bg-slate-900 rounded-2xl overflow-hidden shadow-2xl">
              {/* Header */}
              <div className="flex items-center justify-between px-5 py-3 bg-slate-800/50">
                <h3 className="text-white font-bold text-lg flex items-center gap-2">
                  <Play className="h-5 w-5 text-amber-400 fill-amber-400" />
                  Como Usar o ClubdoCupom
                </h3>
                <button
                  onClick={handleClose}
                  className="text-white/60 hover:text-white hover:bg-white/10 rounded-full p-1.5 transition-all"
                  data-testid="tutorial-modal-close"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              {/* Video */}
              <div className="aspect-video bg-black">
                <video
                  ref={videoRef}
                  controls
                  className="w-full h-full"
                  data-testid="tutorial-video-player"
                >
                  <source src={video.file_url} type="video/mp4" />
                  Seu navegador nao suporta video.
                </video>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
